module.exports = "<div class=\"wrapper-block-ui\">\n  <div class=\"wrapper-block-ui-header\">{{title}}</div>\n  <div class=\"wrapper-block-ui-body\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/block/block-ui.template.html
// module id = ../../../../../src/app/components/block/block-ui.template.html
// module chunks = main